// Agents API client
import request from './request'
import type { AgentInfo, AgentListResponse } from '@/types/workflow'

export const agentsApi = {
  /**
   * Get all agents status
   */
  async getList(): Promise<AgentListResponse> {
    return request.get<AgentListResponse>('/agents')
  },

  /**
   * Get specific agent status
   */
  async getOne(agentName: string): Promise<AgentInfo> {
    return request.get<AgentInfo>(`/agents/${agentName}`)
  },

  /**
   * Activate an agent
   */
  async activate(agentName: string): Promise<any> {
    return request.post(`/agents/${agentName}/activate`)
  },

  /**
   * Deactivate an agent
   */
  async deactivate(agentName: string): Promise<any> {
    return request.post(`/agents/${agentName}/deactivate`)
  },

  /**
   * Get agent logs
   */
  async getLogs(agentName: string, limit = 50): Promise<any> {
    return request.get(`/agents/${agentName}/logs`, { params: { limit } })
  },
}
